export default __webpack_public_path__ + "static/media/female-regular.0b1e90c1.webp";